var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-column-increase",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "804") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,14.977 C15,15.514 14.725,15.951 14.385,15.951 L0.615,15.951 C0.275,15.951 0,15.514 0,14.977 L0,14.977 C0,14.438 0.275,14.001 0.615,14.001 L14.385,14.001 C14.725,14.001 15,14.438 15,14.977 L15,14.977 L15,14.977 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.947,12.258 C3.947,12.635 3.581,12.944 3.131,12.944 L1.908,12.944 C1.457,12.944 1.093,12.635 1.093,12.258 L1.093,8.818 C1.093,8.44 1.457,8.132 1.908,8.132 L3.131,8.132 C3.581,8.132 3.947,8.44 3.947,8.818 L3.947,12.258 L3.947,12.258 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.911,12.259 C8.911,12.637 8.546,12.944 8.096,12.944 L6.872,12.944 C6.422,12.944 6.057,12.637 6.057,12.259 L6.057,7.779 C6.057,7.401 6.422,7.094 6.872,7.094 L8.096,7.094 C8.546,7.094 8.911,7.401 8.911,7.779 L8.911,12.259 L8.911,12.259 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.938,12.232 C13.938,12.607 13.571,12.912 13.114,12.912 L11.878,12.912 C11.422,12.912 11.054,12.607 11.054,12.232 L11.054,5.727 C11.054,5.352 11.422,5.047 11.878,5.047 L13.114,5.047 C13.571,5.047 13.938,5.352 13.938,5.727 L13.938,12.232 L13.938,12.232 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.734,6.921 C0.355,6.92 0.043,6.624 0.029,6.248 C0.015,5.863 0.32,5.542 0.711,5.529 C5.715,5.352 10.479,3.424 13.785,0.236 C14.064,-0.032 14.51,-0.029 14.785,0.248 C15.058,0.522 15.053,0.965 14.774,1.233 C11.168,4.71 6.191,6.73 0.76,6.92 C0.752,6.921 0.742,6.921 0.734,6.921 L0.734,6.921 Z",
    className: "si-glyph-fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.0fdd26932ff4005ae5a32a4ce2e78d41.svg";
export { ForwardRef as ReactComponent };